/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiUTMEntityType;
(function (ApiUTMEntityType) {
    ApiUTMEntityType["UTM_ENTITY_TYPE_AD"] = "UTM_ENTITY_TYPE_AD";
})(ApiUTMEntityType || (ApiUTMEntityType = {}));
export function ApiUTMEntityTypeFromJSON(json) {
    return ApiUTMEntityTypeFromJSONTyped(json, false);
}
export function ApiUTMEntityTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiUTMEntityTypeToJSON(value) {
    return value;
}
